import { render, staticRenderFns } from "./CreateAppointmentModel.vue?vue&type=template&id=1372326e&scoped=true&"
import script from "./CreateAppointmentModel.vue?vue&type=script&lang=js&"
export * from "./CreateAppointmentModel.vue?vue&type=script&lang=js&"
import style0 from "./CreateAppointmentModel.vue?vue&type=style&index=0&id=1372326e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1372326e",
  null
  
)

export default component.exports